import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import CTASection from '../components/sections/CTASection';
import SocialProof from '../components/sections/SocialProof';

const FORMS_URL = "https://forms.gle/n5o3Ld3dCXix5Nqd7";

const differences = [
  { ne: 'obecné příklady', ale: 'konkrétní úkoly z vaší práce' },
  { ne: 'seznam nástrojů', ale: 'práce s AI jako s pomocníkem' },
  { ne: 'přednáška', ale: 'workshop' },
  { ne: 'jen nadšení', ale: 'i realistický pohled na limity AI' },
  { ne: 'univerzální obsah', ale: 'přizpůsobení typu školy' },
];

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>

        {/* Hero */}
        <section className="pt-36 pb-16 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="inline-flex items-center px-4 py-2 bg-teal-50 border border-teal-100 rounded-full text-teal-700 text-sm font-medium mb-8">
              Financovatelné z OP JAK II
            </div>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-slate-900 leading-tight mb-6">
              AI není budoucnost.<br />
              <span className="text-teal-600">AI už máte ve škole.</span>
            </h1>
            <p className="text-xl md:text-2xl text-slate-500 leading-relaxed mb-6 max-w-2xl">
              Vaši žáci AI používají. Část vašich kolegů také.
            </p>
            <p className="text-lg text-slate-600 leading-relaxed max-w-2xl">
              Naše školení není přednáška o budoucnosti.<br />
              Je to <strong className="text-slate-900">pracovní den</strong>, po kterém pedagogové odcházejí s hotovou prací.
            </p>
          </div>
        </section>

        {/* Jinak než ostatní */}
        <section className="py-16 bg-slate-50 border-t border-slate-100">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <p className="text-sm font-semibold text-slate-400 tracking-widest uppercase mb-6">Většina školení o AI funguje takto</p>
            <p className="text-xl text-slate-600 leading-relaxed mb-10 max-w-2xl">
              Lektor ukáže nástroje, všichni nadšeně kývají —<br />
              a v pondělí je všechno stejné jako před školením.
            </p>

            <p className="text-2xl font-bold text-slate-900 mb-8">My to děláme jinak.</p>

            <div className="space-y-4 max-w-2xl">
              {differences.map((d, i) => (
                <div key={i} className="flex items-baseline gap-3">
                  <div className="w-1.5 h-1.5 rounded-full bg-teal-500 flex-shrink-0 mt-2" />
                  <p className="text-base text-slate-500">
                    ne {d.ne},{' '}
                    <strong className="text-slate-900">ale {d.ale}</strong>
                  </p>
                </div>
              ))}
            </div>

            <p className="mt-10 text-lg text-slate-600 leading-relaxed max-w-2xl">
              Pedagogové během školení pracují na tom, co <strong className="text-slate-900">skutečně řeší ve své praxi</strong>.
            </p>
          </div>
        </section>

        {/* Sociální důkaz */}
        <SocialProof />

        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
